import angular from 'angular';

var logo = angular.module('folkeuni').component('svgLogo', {
	transclude: true,
	templateUrl: function() {
		return '/shop-dist/templates/logo.html'
	},
	controller: function () {
		var $ctrl = this;
	}
});